import type { CommonColors } from '@mui/material';

export const common: CommonColors = Object.freeze({
  white: '#ffffff',
  black: '#000000',

  text: {
    primary: '#1E1E1E',
    secondary: '#363643',
    teritary: '#525265',
    inverse: '#ffffff',
    quaternary: '#9FA0B1',
  },

  point: {
    point1: '#BB7CF5',
    point2: '#A670FF',
    point3: '#8F68F6',
    point4: '#7233F9',
  },

  red: {
    50: '#FFFBFB',
    100: '#FFF1F1',
    200: '#FBE0E0',
    600: '#FFB1AF',
    900: '#FF5D58',
  },

  green: {
    50: '#F9FFFA',
    100: '#EFFFF3',
    200: '#B9E0C1',
    600: '#7fc89a',
    900: '#00B100',
    opacity: {
      15: 'rgba(0, 177, 0, 0.15)',
    },
  },

  yellow: {
    200: '#FFFB98',
    opacity: {
      '200-30': 'rgba(255, 251, 152, 0.3)',
      '900-30': 'rgba(248, 201, 36, 0.3)',
      '900-60': 'rgba(248, 201, 36, 0.6)',
    },
    900: '#f8c924',
  },
} as const);
